/* eslint-disable prettier/prettier */
import * as utils from './utils';
import * as yup from 'yup';
import { Fichier } from '../entities';

export const schemaFichier = yup.object<Partial<Fichier>>({
    name: yup.string(),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
}) as yup.ObjectSchema<Partial<Fichier>>;
